import { configureStore } from "@reduxjs/toolkit";
import modalReducer from "../store/modal/modalSlice";
import url from "../store/baseURL/url";
import alert from "../store/alert/alert";

export default configureStore({
  reducer: {
    modal: modalReducer,
    url,
    alert,
  },
});
